export default __webpack_public_path__ + "static/media/FiverrIcon.bf81ef41.svg";